// Moved to components/Table/DataTable — nothing here was products-specific.
// Re-exported so the products screen keeps its own import path.
export { default } from '../../Table/DataTable';
